module.exports = __webpack_public_path__ + "static/media/beauty5.e3eba382.png";